module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"zh-CN":{"title":"AI 推荐关键词指南","description_title":"请尝试针对推荐关键词撰写评价。","description_content":"无需烦恼撰写内容，尝试根据推荐关键词撰写评价吧。AI将分析文本以判断是否包含关键词内容。","disclaimer":"*AI分析可能存在误差，并可能影响实际发放的奖励金额。"}}')
  delete Component.options._Ctor
}
